@if (type() === categoryTreeTypeEnum.listCRUD) {
  <section class="content">
    <div class="card">
      <loading-spinner [isLoading]="loading" [classesString]="'top-50'"></loading-spinner>
      @if (
        (!loading && !queryCategoriesOptions.data()) ||
        (!loading && queryCategoriesOptions.data() && queryCategoriesOptions.data().length === 0)
      ) {
        <ul class="list-unstyled">
          <li class="list-group-item">
            {{ 'no.categories' | translate }}
          </li>
        </ul>
      }
      @if (queryCategoriesOptions.data() && queryCategoriesOptions.data().length > 0) {
        <ul
          class="list-unstyled"
          dndDropzone
          dndEffectAllowed="move"
          (dndDrop)="onDrop($event, queryCategoriesOptions.data())"
        >
          <li dndPlaceholderRef class="categoriesListDndPlaceholder"></li>
          @for (category of queryCategoriesOptions.data(); track category) {
            <category-tree-row
              [category]="category"
              [type]="categoryTreeTypeEnum.listCRUD"
              [dndDraggable]="category"
              dndEffectAllowed="move"
              (dndMoved)="onDragMove(category, queryCategoriesOptions.data())"
            ></category-tree-row>
          }
        </ul>
      }
    </div>
  </section>
}

@if (
  type() !== categoryTreeTypeEnum.listCRUD &&
  ((categories() && categories()?.length > 0) ||
    (queryCategoriesOptions.data() && queryCategoriesOptions.data()?.length > 0))
) {
  @if (!isInBulkEdits() && !isForFilterCategories() && categoryTreeLabel() && categoryTreeLabel().length > 0) {
    <label>{{ categoryTreeLabel() | translate }}:</label>
  }
  @if (type() === categoryTreeTypeEnum.radioParentCategory) {
    <ul class="list-unstyled">
      @for (category of categories().length > 0 ? categories() : queryCategoriesOptions.data(); track category) {
        <category-tree-row
          [category]="category"
          [editedCategory]="editedCategory()"
          (editedCategoryChange)="editedCategoryChanged($event)"
          [type]="categoryTreeTypeEnum.radioParentCategory"
        ></category-tree-row>
      }
    </ul>
  }
  @if (type() === categoryTreeTypeEnum.radioProductMainCategory) {
    <ul class="list-unstyled">
      @for (category of categories().length > 0 ? categories() : queryCategoriesOptions.data(); track category) {
        <category-tree-row
          [category]="category"
          [mainCategory]="mainCategory()"
          (mainCategoryChange)="mainCategoryValueChanged($event)"
          [type]="categoryTreeTypeEnum.radioProductMainCategory"
        ></category-tree-row>
      }
    </ul>
  }
  @if (type() === categoryTreeTypeEnum.checkboxProductCategories) {
    <ul class="list-unstyled">
      @for (category of categories().length > 0 ? categories() : queryCategoriesOptions.data(); track category) {
        <category-tree-row
          [category]="category"
          [selectedCategories]="selectedCategories()"
          (selectedCategoriesChange)="categoriesChanged($event)"
          [isInBulkEdits]="isInBulkEdits()"
          [isForFilterCategories]="isForFilterCategories()"
          [type]="categoryTreeTypeEnum.checkboxProductCategories"
        ></category-tree-row>
      }
    </ul>
  }
}
